import { useCallback } from "react";

import type { VoucherIssuedMarkVoucherAsUnUsedInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { VoucherIssuedMarkVoucherAsUnUsed_DetailsPage_Mutation } from "./mutation";
import { VoucherIssuedForCampaignListByHotelIDAndVoucherID_DetailsPage_Query } from "../../query/query";

type Props = {
	voucherID: string;
};

export const useMarkVoucherAsUnUsedMutation = ({ voucherID }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(VoucherIssuedMarkVoucherAsUnUsed_DetailsPage_Mutation);

	const onUpdateMarkVoucherAsUnUsed = useCallback(
		async (
			input: VoucherIssuedMarkVoucherAsUnUsedInput, //
		) => {
			showLoadingScreenCallback();

			const { errors } = await mutationFunc({
				variables: {
					input,
				},
				refetchQueries: [
					{
						query: VoucherIssuedForCampaignListByHotelIDAndVoucherID_DetailsPage_Query,
						variables: {
							hotelID: input.hotelID,
							voucherID,
						},
					},
				],
			}).finally(() => {
				hideLoadingScreenCallback();
			});

			if (!errors) {
				notifyUserEventInfo({
					title: "キャンペーンを更新しました",
				});

				return true;
			} else {
				return false;
			}
		},
		[hideLoadingScreenCallback, mutationFunc, showLoadingScreenCallback, voucherID],
	);

	return { onUpdateMarkVoucherAsUnUsed };
};
